import { isMobile } from 'react-device-detect';

//レイアウト用の計算
function calulateSize(newWidth, newHeight, wrapWidthRef, canvasRef, eachWidthRef, avatarCount) {
  //値
  const scale = window.devicePixelRatio || 1; //スケール
  var isWidthBiggerThanHeight = true; //縦が大きいのか、横が大きいのか
  var isPortrait = false; //ポートレイトかどうか

  //縦が大きいか横か
  if (newWidth != null && newHeight != null) {
    if (newWidth < newHeight) {
      isWidthBiggerThanHeight = false;
    }
  } else {
    if (canvasRef.current?.offsetWidth < canvasRef.current?.offsetHeight) {
      isWidthBiggerThanHeight = false;
    }
  }

  //モバイルの場合
  if (isMobile) {
    isPortrait = window.matchMedia('(orientation: portrait)').matches;
  }

  /*------------------------------- 幅のほうが長い場合 ------------------------------ */

  //console.log('サイズだよ');
  //console.log(canvasRef.current?.offsetHeight);
  //console.log(canvasRef.current?.offsetWidth);

  let h = canvasRef.current?.offsetHeight;
  let w = canvasRef.current?.offsetWidth;

  //横幅が縦よりも長い場合
  if (isWidthBiggerThanHeight && isPortrait == false) {
    let ratio = w / h;
    let eachWidth = h * 0.6; //* (ratio * 0.5);
    // console.log(ratio);
    // console.log(d);

    // if (newWidth != null) {
    //   wrapWidthRef.current = newWidth;
    // } else {
    //   wrapWidthRef.current = w;
    // }

    wrapWidthRef.current = w * 0.9; //(w * 0.9 * 1.7) / ratio;

    if (avatarCount * eachWidth <= w) {
      eachWidthRef.current = eachWidth; //個別
    } else {
      eachWidthRef.current = w / avatarCount; //個別
    }

    return [w, h];
  }
  //縦の方が長い場合
  else {
    //高さは幅と同じに
    wrapWidthRef.current = w * 0.95;

    //各幅を指定
    if (avatarCount == 1 || avatarCount == 2) {
      eachWidthRef.current = w / 1.8;
    } else {
      eachWidthRef.current = (w / avatarCount) * 1.4;
    }

    // if (avatarCount == 3) {
    //   eachWidthRef.current = widthNow / 2;
    // }

    return [w, h];
  }

  // 2  1000 => 800
  // 1.5  750 => 650
  // 1 （正方形）500

  if (isWidthBiggerThanHeight && isPortrait == false) {
    //各種値
    let widthNow; //キャンバスの幅
    var heightNow = canvasRef.current?.offsetHeight; //キャンバスの高さ
    var heighMulti = 1; //高さのウェイト

    if (newWidth != null) {
      widthNow = newWidth;
    } else {
      widthNow = canvasRef.current?.offsetWidth;
    }

    //高さに応じて、比率を変える
    if (heightNow < 400) {
      if (avatarCount == 1 || avatarCount == 2 || avatarCount == 3) {
        heighMulti = 0.5;
      }
      if (avatarCount == 4) {
        heighMulti = 0.7;
      }

      if (avatarCount == 5) {
        heighMulti = 0.8;
      }
    } else if (heightNow < 500) {
      if (avatarCount == 1 || avatarCount == 2 || avatarCount == 3) {
        heighMulti = 0.6;
      }

      if (avatarCount == 4) {
        heighMulti = 0.8;
      }

      if (avatarCount == 5) {
        heighMulti = 0.9;
      }
    } else if (heightNow < 600) {
      if (avatarCount == 1 || avatarCount == 2 || avatarCount == 3) {
        heighMulti = 0.7;
      }
      if (avatarCount == 4) {
        heighMulti = 0.9;
      }
    } else if (heightNow < 700) {
      if (avatarCount == 1 || avatarCount == 2) {
        heighMulti = 0.8;
      }
      if (avatarCount == 3) {
        heighMulti = 0.9;
      }
    } else if (heightNow < 800) {
      if (avatarCount == 1 || avatarCount == 2) {
        heighMulti = 0.9;
      }
    } else {
      heighMulti = 1;
    }

    //全てのアバターが入る箱の幅を決める
    if (widthNow > 1000) {
      wrapWidthRef.current = 1000 * heighMulti;
    } else {
      wrapWidthRef.current = widthNow * heighMulti - 100;
    }

    //一人か二人の時
    if (avatarCount == 1 || avatarCount == 2) {
      eachWidthRef.current = wrapWidthRef.current / 2;
    } else if (avatarCount == 3) {
      eachWidthRef.current = wrapWidthRef.current / 2;
    } else if (avatarCount == 4) {
      eachWidthRef.current = wrapWidthRef.current / 2.5;
    } else if (avatarCount == 5) {
      eachWidthRef.current = wrapWidthRef.current / 3;
    } else if (avatarCount == 6) {
      eachWidthRef.current = wrapWidthRef.current / 3.2;
    }

    return [widthNow, newHeight];
  } else {
    /*------------------------------- 高さのほうが高い場合 ------------------------------ */

    var widthNow;
    var heightNow;

    //全体の幅を指定
    if (newWidth != null) {
      widthNow = newWidth;
    } else {
      widthNow = canvasRef.current?.offsetWidth;
    }

    //モバイルのiPhoneSE対策
    if (isWidthBiggerThanHeight) {
      widthNow = canvasRef.current?.offsetHeight;
    }

    //高さは幅と同じに
    heightNow = widthNow;
    wrapWidthRef.current = widthNow;

    //各幅を指定
    if (avatarCount == 1 || avatarCount == 2) {
      eachWidthRef.current = widthNow / 1.4;
    }

    if (avatarCount == 3) {
      eachWidthRef.current = widthNow / 2;
    }

    return [widthNow, heightNow];
  }
}

export { calulateSize };
